export default {
  esgPlatform: {
    esgDashboard: "ESG Dashboard",
    esgPlatform: "ESG Platform",
    myProtocol: "My Sustainability Guide",
    esgProgress: "ESG Progress",
    common: {
      myProducts: "My Products",
      esgCompliance: "ESG Compliance",
      active: "Active",
      deactivated: "Deactivated",
    },

    surveyTitlePlaceholder: "Survey Title",
    selectHeading: "Select Heading",
    headingDeleteConfirmationText: "Are you sure you want to delete this heading?",
    questionDeleteConfirmationText: "Deleting this question will permanently remove all responses submitted by users across the enterprise and sub-enterprises. This will also impact the ESG progress linked to this question.  This action cannot be undone. Do you want to proceed?",
    confirmDelete: "Confirm",
    cancelDelete: "Cancel",
    farmerSingleResponse: "Farmer (Single response for all farms)",
    farmerSeparateResponse: "Farmer (Separate response for each farm)",
    fixedFrequency: "Fixed Frequency",
    custom: "Custom",
    day: "Day",
    week: "Week",
    month: "Month",
    quarter: "Quarter",
    year: "Year",
    textField: "Text Field",
    textArea: "Text Area",
    textFieldNumeric: "Text Field Numeric",
    radioButton: "Radio Button",
    checkBoxes: "Check Boxes",
    getDataLabel: "Get Data",
    attachFiles: "Attach Files",
    digitalSignature: "Digital Signature",
    editSurvey: "Edit Survey",
    editSurveyWarning: "Please note that the survey is currently live, and editing a question at this time may impact previous submissions. To avoid any issues, you may consider creating a copy of the survey in order to make changes to the questions.",
    clickToCreateCopy: "Click Here To Create Survey Copy",
    continueAndEdit: "Continue and Edit",
    surveyBuilderEsg: "Survey Builder",
    loadingAssessments: "Loading Assessments...",
    noSurveysFound: "No Surveys Found",
    searchSurveysByTitle: "Search surveys by title...",
    editAssessmentQuestion: "Edit Assessment Question",
    addAssessmentQuestion: "Add Assessment Question",
    score: "Score",
    whoWillAnswerThisQuestion: "Who will answer this question?",
    whoWillAnswerTooltip: "Who will answer this question.",
    questionType: "Question Type",
    typeOfQuestion: "Type of question",
    titleTooltip: "Title of the question",
    enterHere: "Enter here",
    condition: "Condition",
    addDataField: "Add Data Field",
    dataField: "Data Field",
    fileType: "File Type",
    allowMultipleAttachments: "Allow Multiple Attachments",
    allowComments: "Allow Comments",
    uploadSignatureFile: "Upload Signature File",
    drawSignature: "Draw Signature",
    description: "Description",
    descriptionTooltip: "Brief description of the question",
    addOption: "Add Option",
    addOptionTooltip: "Add a new option to the list",
    add: "Add",
    pressEnterToAdd: "Press Enter to add an option or click on Add",
    options: "Options",
    repeatPeriodically: "Repeat Periodically (Optional)",
    repeatPeriodicallyTooltip: "Repeat Periodically (Optional).",
    enabled: "Enabled",
    disabled: "Disabled",
    yes: "Yes",
    no: "No",
    selectDate: "Select Date",
    repetitionDates: "Repetition Dates",
    repetitionDatesTooltip: "Dates in which the question is repeated.",
    repeatsEvery: "Repeats Every",
    repetitions: "Repetitions",
    selectStartDate: "Select Start Date",
    cancel: "Cancel",
    ok: "OK",
    submit: "Submit",
    requireFileAttachment: "Require File Attachment",
    standardSurvey: "Standard Survey",
    riskAssessmentSurvey: "Risk Assessment Survey",
    esgGoalSurvey: "ESG Goal Survey",
    rwaSurvey: "RWA Survey",
    cannotGetAssessments: "Cannot get assessments",
    assessmentDeletedSuccessfully: "Assessment deleted successfully",
    cannotDeleteAssessment: "Cannot delete assessment",
    errorDeletingAssessment: "Error deleting assessment",
    goalProgress: "Goal Progress",
    selectSegment: "Select Segment",
    selectTopics: "Select Topics",
    selectGoal: "Select Goal",
    selectedGoal: "Selected Goal",
    searchSubOrganization: "Search Sub-Organization",
    actions: "Actions",
    licenseId: "License ID",
    exportAsCsv: "Export as CSV",
    registerUser: "Register User(s)",
    enterpriseUsers: "Enterprise users",
    singleUser: "Single User",
    multipleUser: "Multiple User",
    selectStandard: "Select Standard",
    country: "Country",
    product: "Product",
    clear: "Clear",
    selectStandards: "Select Standards",
  sdgGoalsUpdated: "SDG Goals updated successfully",
  errorLoadingSDGGoals: "Error loading SDG Goals",
  errorUpdatingSDGGoals: "Error updating SDG Goals",
  allSelectedSDGGoals: "All Selected SDG Goals",
  selectSDGGoals: "Select SDG Goals",
  sdgGoals: "SDG Goals",
    title: "ESG Platform",
    esgCompliance: "ESG Compliance",
    standards: "Standards",
    addNewStandard: "Add New Standard",
    surveyType: "Survey Type",
    addNewSurvey: "Add New Survey",
    surveyDescription: "Survey Description",
    surveyDescriptionTT: "Enter the description of the survey",
    surveyInstructions: "Survey Instructions",
    surveyInstructionsTT: "Enter the instructions for the survey",
    surveyScore: "Survey Score",
    surveyScoreTT: "Allow scoring survey",
    whoWillAnswerThisSurvey: "Who Will Answer This Survey?",
    whoWillAnswerThisSurveyTT: "Select the type of users who will answer this survey",
    typeOfTheSurvey: "Type of the Survey",
    standardTitle: "Standard Title",
    standardTitleTT: "Enter the title of the standard",
    shortCode: "Short Code",
    shortCodeTT: "Enter the short code of the standard",
    standardDescription: "Standard Description",
    standardDescriptionTT: "Enter the description of the standard",
    seal: "Seal",
    sealTT: "Select the seal of the standard",
    status: "Status",
    upload: "Upload",
    thisfieldIsRequired: "This field is required",
    pleaseFillRequiredFields: "Please fill the required fields",
    standardAddedSuccessfully: "Standard added successfully",
    errorSubmittingForm: "Error submitting form",
    createNewEsgStandard: "Create New ESG Standard",
    close: "Close",
    settings: "Settings",
    next: "Next",
    keyIssuesAndGoals: "Key Topics and Goals",
    keyIssuesAndGoalsTT: "Key topics and goals of the standard",
    environmental: "Environmental",
    issues: "Topics",
    addIssue: "Add Topic",
    social: "Social",
    governance: "Governance",
    goals: "Goals",
    target: "Target (Years)",
    questions: "Questions",
    type: "Type",
    mandatory: "Mandatory",
    addNewGoal: "Add New Goal",
    deleteIssueConfirmation:
      "Are you sure you want to delete this topic? Deleting this topic will also permanently delete all associated goals and questions. This action cannot be undone.",
    deleteGoalConfirmation:
      "Are you sure you want to delete this goal? Deleting this goal will also permanently delete all associated questions. This action cannot be undone.",
    deleteConfirmation:
      "Are you sure you want to delete? This action cannot be undone.",
    standardSettings: "Standard Settings",
    standardStatus: "Standard Status",
    active: "Active",
    inactive: "Inactive",
    approvalMethod: "Approval Method",
    approveManually: "Approve Manually",
    scoreForApproval: "Score for Approval",
    overallProtocolScore: "Overall Sustainability Guide Score",
    overallProtocolScoreTT: "Enter the overall Sustainability Guide score",
    heading: "Heading",
    selectHeadingTooltip: "Select a heading for the survey question",
    survey: "Survey",
    goalTitle: "Goal Title",
    goalTitleTT: "Enter the title of the goal",
    goalTargetYear: "Goal Target Year",
    environmetalScore: "Environmental Score",
    environmetalScoreTT: "Enter the environmental score",
    socialScore: "Social Score",
    socialScoreTT: "Enter the social score",
    governanceScore: "Governance Score",
    governanceScoreTT: "Enter the governance score",
    mandatoryApproval: "Mandatory Approval",
    preview: "Preview",
    pleaseAddAtLeastOneIssueAndGoal:
      "Please add at least one topic with at least one goal before proceeding to the preview.",
    noContentToPreview:
      "There is no content to preview. Please add at least one topic and goal.",
    standardPreview: "Standard Preview",
    saveStandard: "Save Standard",
    standardSavedSuccessfully: "Standard saved successfully!",
    standardDeletedSuccessfully: "Standard deleted successfully!",
    protocolDeletedSuccessfully: "Sustainability Guide deleted successfully!",
    standardUpdatedSuccessfully: "Standard updated successfully!",
    pleaseEnterWholeNumberBetween0and100:
      "Please enter percentage between 0 and 100",
    issueCreatedSuccessfully: "Topic created successfully",
    errorCreatingIssue: "Error creating topic. Please try again.",
    issueTitleUpdatedSuccessfully: "Topic title updated successfully",
    errorUpdatingIssueTitle: "Error updating topic title. Please try again.",
    issueDeletedSuccessfully: "Topic deleted successfully",
    errorDeletingIssue: "Error deleting topic. Please try again.",
    goalCreatedSuccessfully: "Goal created successfully",
    errorCreatingGoal: "Error creating goal. Please try again.",
    goalUpdatedSuccessfully: "Goal updated successfully",
    errorUpdatingGoal: "Error updating goal title. Please try again.",
    errorDeletingGoal: "Error deleting goal. Please try again.",
    goalDeletedSuccessfully: "Goal deleted successfully",
    standardActivatedSuccessfully: "Standard activated successfully",
    goalTitleRequired: "Goal title is required",
    questionsRequired: "Questions are required",
    noSurveyAvailable: "No survey available",
    myProducts: {
      addNewProduct: "Add New Product",
      lastUpdated: "Last Updated",
      addedBy: "Added By",
    },
    dashboard: {
      subEnterprises: "Sub-Enterprises",
      registerSubEnterprise: "Register Sub-Enterprise",
      exportAsCSV: "Export as CSV",
      enterprise: "Enterprise",
      licenseID: "License ID",
      membershipPlan: "Membership Plan",
      activationKeys: "Activation Keys",
      users: "Users",
      registrationDate: "Registration Date",
      country: "Country",
      status: "Status",

      countryPlaceholder: "Select country",
      enterpriseName: "Enterprise Name",
      enterpriseNamePlaceholder: "Enter enterprise name",
      enterpriseEmail: "Enterprise Email",
      enterpriseEmailPlaceholder: "Enter email address",
      enterprisePhoneNumber: "Enterprise Phone Number",
      enterprisePhoneNumberPlaceholder: "Enter phone number",
      provincePlaceholder: "Enter province/state",
      regionPlaceholder: "Enter region/district",
      villagePlaceholder: "Enter village/town/city",
      address: "Address",
      province: "Province/State",
      region: "Region/District",
      village: "Village/Town/City",
      addressPlaceholder: "Enter address",
      dateOfRegistration: "Date of Registration",
      dateOfRegistrationPlaceholder: "Select registration date",
      subscriptionUpTo: "Subscription Up To",
      subscriptionUpToPlaceholder: "Select subscription end date",
      products: "Products",
      initialAssessmentReport: "Initial Assessment Report",
      enterHere: "Enter Here",
      attachInitialAssessmentReport: "Attach Initial Assessment Report",
      linkWithProducts: "Link with Products",
      linkWithProductsPlaceholder: "Select linked products",
      uploadLogo: "Upload Logo",
      uploadLogoPlaceholder: "Upload enterprise logo",
      licenseIDPlaceholder: "Enter License ID",

      deactivateAccount: "Deactivate Account",
      activateAccount: "Activate Account",
      deactivateMsg: "Are you sure you want to deactivate this account?",
      activateMsg: "Are you sure you want to activate this account?",
      deleteAccount: "Delete Account",
      deleteMsg: "Are you sure you want to remove this account?",
    },

    activate: "Activate",
    confirmation: "Confirmation",
    standardDeleteConfirmation:
      "Are you sure you want to delete this standard?",
    protocolDeleteConfirmation:
      "Are you sure you want to delete this Sustainability Guide?",
    surveyQuestionForTheGoal: "Survey Question for the Goal",
    selectExistingESGSurveyOrCreateNew:
      "Select existing ESG survey or create new",
    surveyBuilder: 'ESG Survey Builder',
    surveyDetails: 'Survey Details',
    createnewSurvey: "Create new survey",
    startContinueSurvey: "Start/Continue Survey",
    surveyOverview: "Survey Overview",
    surveyTitle: "Survey Title",
    surveyTitleTT: "Enter the title of the survey",
    surveyCompletionPercentage: "Survey Completion Percentage",
    inProgress: "In Progress",
    surveyProgress: "Survey Progress",
    howToCompleteSurvey: "How to Complete Survey",
    confirmSurveyResponse:
      "You are about to submit your response. Please confirm if you would like to proceed.",
    progress: {
      progress: "Progress",
      dashboard: "Dashboard",
      esgProgress: "ESG Progress",
      companyName: "Company Name",
      search: "Search",
      select: "Select",
      country: "Country",
      standard: "Standard",
      subOrganization: "Sub-Organization",
      protocols: "Sustainability Guide",
      actions: "Actions",
      subOrganizations: "Sub-Organizations",
      downloadReport: "Download Report",
      comparison: "Comparison",
      messages: "Messages",
      validateData: "Validate Data",
      recommendations: "Recommendations",
      ESRSIssueAndGoals: "ESRS Topics and Goals",
      protocolProgress: "Sustainability Guide Progress",
    },
    validation:{
      dataValidations: "Data Validations",
      validateData:  "Validate Data",
      inputData: "Input Data",
      question: "Question",
      issueAndGoal: "Topic & Goal",
      environmental: "Environmental",
      social: "Social",
      governance: "Governance",
      search: "Search",
      rejectionSuccess: "Rejection reason submitted successfully.",
      rejectionFailed: "Failed to submit rejection reason. Please try again.",
    },
    startNewEsgProtocol: "Start New ESG Sustainability Guide",
    getStartedWithEsg: "Get Started with ESG",
    getStartedEsgMsg:
      "No Sustainability Guide have been added yet. Add a Sustainability Guide to begin your journey toward effective ESG management and reporting.",
    startEsgProtocol: "Start ESG Sustainability Guide",
    createNewProtocolWithoutStandard: "Create new Sustainability Guide without a standard",
    selectEsgStandard: "Select ESG Standard",
    addNewProtocol: "Add New Sustainability Guide",
    protocolTitle: "Sustainability Guide Title",
    subOrganization: "Sub-Organizations",
    protocolAddedMsg: "Sustainability Guide added successfully.",
    existingProtocols: "Existing Sustainability Guide",

    protocolSettings: "Sustainability Guide Settings",
    protocolSettingsUpdated: "Sustainability Guide settings successfully updated.",
    failedToUploadFile: "Failed to upload image. Please try again.",
    failedToUploadFileToS3: "Failed to upload image to s3",

    selectSubOrg: "Select Sub-Organizations",
    selectSubOrgMsg:
      "Select the sub-organization for which you are setting targets and goals related to ESG (Environmental, Social, and Governance) protocols. This option allows you to specify which part of your organization is responsible for implementing and tracking these objectives. By assigning goals to individual sub-organizations, you can tailor ESG initiatives to address specific operational needs and impacts, ensuring a focused approach to sustainability and governance at different organizational levels.",
    selectedSubOrg: "Selected Sub-Organizations",
    subOrgs: "Sub-Organizations",
    activityLog: "Activity Log",
    activityLogFor: "Activity Log For",
    activityLogDesc:
      "Track all changes made to ESG goals, questions, and topics, including additions, edits, and deletions, with details on the user, action, and timestamp",
    protocolActivatedSuccessfully: "Sustainability Guide activated successfully",

    activationKey: "Activation Key",
    userNameAndId: "User Name & ID",
    email: "Email",
    userRole: "User Role",
    userRegistrationDate: "User Registration Date",
    protocolUpdatedSuccessfully: "Sustainability Guide updated successfully.",

    createNewProtocol: "Create new Sustainability Guide",
    myProtocols: "My Sustainability Guide",


    viewDetails: "View Details",
    viewProgressByGoal: "View Progress By Goal",
    downloadReport: "Download Report",
    chooseTimeFrame: "Choose the time frame for the report you would like to download.",
    downloading: "Downloading",
    downloadingDesc: "Your ESG Sustainability Guide report is being prepared for download. Please wait while we generate the file.",
    updateStatus: "Update Status",
    updateStatusDesc: "Please select the new status for the Abrafrutas Sustainability Guide/Fruit Growers for the sub-organization AGRICULTURA DO VALE LTDA - AGRIVALE.",

    validationConfirm: "Confirmation",
    validationConfirmMsg: "Are you sure you want to reject this response? The user will need to submit the response again. This action cannot be undone.",
    validationRejectionReason: "Reason for Rejection",
    validationRejectionReasonPlaceholder: "Type here",

    inputData: "Input Data",
    question: "Question",
    issueGoal: "Topic & Goal",
    surveyResponseText: "Survey Response",

    goal: "Goal",
    submittedBy: "Submitted By",
    dateSubmitted: "Date Submitted",
    responses: "Responses",
    uploadedDocument: "Uploaded Document",
    noFilesUploaded: "No files uploaded",
    getData: "Get Data",
    recommendations: "Recommendations",
    actionPlan: "Action Plan",

    subOrganizations: "Sub Organizations",
    farms: "Farms",
    farmers: "Farmers",
    totalGoals: "Total Goals",
    startDate: "Start Date",
    deadline: "Deadline",
    standard: "Standard",
    goalsProgress: "Goals Progress",
    esrsProtocol: "ESRS Sustainability Guide",


    surveyResponse: {
      enterYourAnswer: "Enter your answer",
      fieldRequired: "This field is required",
      additionalQuestions: "Additional Questions",
      previous: "PREVIOUS",
      skip: "SKIP",
      submit: "SUBMIT",
      next: "NEXT",
      step: "Step",
      of: "of",
      question: "Question",
      errorLoadingStandard: "Error loading standard",
      errorLoadingQuestions: "Error loading questions",
      errorSubmittingSurvey: "Error submitting survey",
      surveySubmittedSuccess: "Survey submitted successfully",
      loadingGoalTitle: "Loading goal title...",
      questionOf: "Question {current} of {total}",
      ratingScale: {
        title: "Use the Rating Scale",
        description:
          "For questions that utilize a rating scale (e.g., 1 to 5), please consider the following:",
        stronglyDisagree: "1 = Strongly Disagree",
        disagree: "2 = Disagree",
        neutral: "3 = Neutral",
        agree: "4 = Agree",
        stronglyAgree: "5 = Strongly Agree",
        chooseNumber: "Choose the number that best reflects your opinion.",
      },
      instructions: {
        readCarefully: "Read Each Question Carefully",
        readDescription:
          "Take your time to understand each question before selecting your response. The survey includes a mix of multiple-choice, rating scale, and open-ended questions.",
        beHonest: "Be Honest and Transparent",
        beHonestDescription:
          "Your answers will help us assess our current practices and identify areas for improvement. Please provide honest feedback based on your experiences.",
        provideExamples: "Provide Specific Examples",
        provideExamplesDescription:
          "In open-ended questions, feel free to include specific examples or suggestions. Your detailed feedback will be invaluable in shaping our ESG initiatives.",
        reviewResponses: "Review Your Responses",
        reviewResponsesDescription:
          "Before submitting the survey, take a moment to review your answers. Ensure that you are satisfied with your responses and that all questions have been addressed.",
        submitSurvey: "Submit the Survey",
        submitSurveyDescription:
          "Once you are confident in your responses, click the 'Submit' button at the end of the survey. Your participation is greatly appreciated!",
        contactSupport: "Contact Us for Assistance",
        contactSupportDescription:
          "If you encounter any topics or have questions while completing the survey, please reach out to our support team at [support email] or [support phone number].",
      },
      actionPlans: "Action Plans",
      uploadEvidence: "Upload the Evidence",
      fileUploadSuccess: "File Uploaded Sucessfully",
      fileUploadError: "Error uploading file",
      selectMeasurementUnit:"Select Measurement Unit",
      selectFile:"Select file to Upload the Data",
      dragDrop:"or drag & drop here",
      recommendations:"Recommendations",
      signatureRequired: "Signature is required",
      waitForFileUpload: "Please wait for the file to upload",
      fileRequired: "File is required",
      getDataQuestions: "Get Data Questions",
    },

    validateData: "Validate Data",
    messages: "Messages",
    comparision: "Comparision",
    download: "Download",
    issueAndGoal: "Topic & Goal",
    reasonForRejection: "Reason for Rejection",
    listOfUsers: "List of Users",
    totalUsers: "Total Users",
    viewQuestionsRecommendations: "View Questions Recommendations",
    protocolDetails: "Sustainability Guide Details",
    esgReport: {
      esgReportBuilder: "ESG Report Builder",
      manageTemplates: "Manage Templates",
      createNewEsgReport: "Create New ESG Report",
      listOfReports: "List of Reports",
      reportId: "Report ID",
      template: "Template",
      access: "Access",
      dateGenerated: "Date Generated",
      status: "Status",
      fileUploadFailed: "File upload failed",
      unsupportedFileFormat: "Unsupported file format",
      errorUploadingFile: "Error uploading file",
      view: "View",
      edit: "Edit",
      download: "Download",
      copyAndCreateNew: "Copy and Create New",
      delete: "Delete",
      esgReportTemplates: "ESG Report Templates",
      back: "Back",
      createNewTemplate: "Create New Template",
      listOfTemplates: "List of Templates",
      esgPlatform: "ESG Platform",
      reportBuilder: "Report Builder",
      createTemplate: "Create Template",
      preview: "Preview",
      tooltipCreateTemplate: "Add new template",
      tooltipPreview: "Preview and save your template",
      deleteEsgReport: "Delete ESG Report",
      confirmDeleteReportMessage: "Are you sure you want to delete this report?",
      cancel: "Cancel",
      templateName: "Template Name",
      nameOfTemplate: "Name of Template",
      next: "Next",
      reportPreviewMessage: "This is where the report preview will be displayed.",
      save: "Save",
      confirmationTitle: "Confirmation",
      confirmationMessage: "Are you sure you want to save your changes?",
      confirm: "CONFIRM",
      createEsgTemplate: "Create ESG Template",
      templateSettings: "Template Settings",
      section: "Section",
      addBlock: "Add Block",
      addNew: "Add New",
      customSections: "Custom Sections",
      databaseDrivenSections: "Database Driven Sections",
      submit: "Submit",
      heading: "Heading",
      paragraph: "Paragraph",
      image: "Image",
      stakeholders: "Stakeholders",
      table: "Table",
      esgProgressLineChart: "ESG Progress Line Chart",
      esgScorecard: "ESG Scorecard",
      backgroundColor: "Background Color",
      fontColor: "Font Color",
      font: "Font",
      pdfHeader: "PDF Header",
      reportHeaderLogo: "Report Header Logo",
      uploadLogo: "Upload Logo",
      addImage: "Add Image",
      pleaseWait: "Please Wait",
      defaultLogo: "Default Logo",
      sectionSettings: "Section Settings",
      selectSectionTimeline: "Select Section Timeline",
      lockSectionForSubOrganization: "Lock Section for Sub-Organization",
      sectionTimelineHint: "This timeline applies to this section only",
      sectionLockedHint: "If locked, this section cannot be modified by sub-orgs.",
      createEsgReport: "Create ESG Report",
      close: "Close",
      reportTypeSelection: "Report Type Selection",
      reportTimeline: "Report Timeline",
      selectTimeline: "Select Timeline",
      addNewSection: "Add a New Section",
      previewReport: "Preview Report",
      previewPlaceholder: "This is where the report preview will be displayed.",
      finish: "Finish",
      editEsgReport: "Edit ESG Report",
      saveChanges: "Save Changes",
      esgReport: "ESG Report",
      downloadReport: "Download Report",
      downloadAsPdf: "Download as PDF",
      downloadAsPdfNoImages: "Download as PDF (without images)",
      breadcrumbEsgPlatform: "ESG Platform",
      breadcrumbReportBuilder: "Report Builder",
      breadcrumbCreateReport: "Create Report",
      stepReportDetails: "Report Details",
      stepReportDetailsTooltip: "Configure report details and settings",
      stepCustomizeReport: "Customize Report",
      stepCustomizeReportTooltip: "Add sections and customize content",
      stepPreview: "Preview",
      stepPreviewTooltip: "Preview and publish your report",
      publicReport: "Public Report",
      internalReport: "Internal Report",
      confirmText: "CONFIRM",
      cancelText: "CANCEL",
      closeConfirmTitle: "Confirm Close",
      closeConfirmMessage: "Are you sure you want to close the report? Your progress will be saved, and the report status will be set to 'Saved'. You can resume editing later.",
      selectEsgProgram: "Select ESG Program",
      noProtocolDetails: "No details available for the selected protocol.",
      overallProgress: "Overall Progress",
      environmentalProgress: "Environmental Progress",
      socialProgress: "Social Progress",
      governanceProgress: "Governance Progress",
      subOrganization: "Sub-Organization",
      environmental: "Environmental",
      social: "Social",
      governance: "Governance",
      actions: "Actions",
      name: "Name",
      type: "Type",
      selectTemplate: "Select a Template",
      createNew: "Create New",
      startNow: "Start Now",
      select: "Select",
      esgProgressLineGraph: "ESG Progress Line Graph",
      selectEsgComponents: "Select ESG Components to show on graph:",
      componentSettings: "Component Settings",
      enterSectionTitle: "Enter Section Title",
      colorBlue: "Blue",
      colorWhite: "White",
      colorPrimaryGreen: "Primary Green",
      colorDarkGreen: "Dark Green",
      colorBlack: "Black",
      colorGrey: "Grey",
      colorCustom: "Custom...",
      headingSize: "Heading Size",
      headingTitle: "Heading Title",
      overview: "Overview",
      selectImageType: "Select Image Type",
      singleImage: "Single Image",
      imageGrid: "Image grid",
      gridSize: "Grid Size",
      images: "Images",
      stakeholder: "Stakeholder",
      message: "Message",
      addNewStakeholder: "Add New Stakeholder",
      enterMessageHere: "Enter message here",
      noOfColumns: "No. of Columns",
      noOfRows: "No. of Rows",
      column: "Column",
      columnName: "Column Name",
    }
  },
};